import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import { Switch, Button
} from '@material-ui/core';
import GearIcon from '@material-ui/icons/SettingsSharp'; 

import PropTypes from 'prop-types';
import moment from 'moment';


const styles = (theme) => ({
    root: {
        minHeight: 450,
        minWidth: 300,
        fontFamily: 'Helvetica',
        '@media only screen and (max-width: 450px)': {
            // marginLeft: 0,
            // paddingTop: 54,
        },
    },
    content: {
        padding: 24,
        fontSize: 14,
        marginBottom: 32,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 20
    },
    column: {
        display: 'inline-block',
        verticalAlign: 'top',
    },
    vertLine: {
        display: 'inline-block',
        marginLeft: 12,
        marginRight: 12,
        width: 1,
        height: '200px',
        borderLeft: '1px solid #cccccc88',
        verticalAlign: 'top',
    },
    item: {
        width: 120,
        display: 'inline-block',
    },
    buttonArea: {
        position: 'absolute',
        bottom: 24,
        right: 32
    }
});



export class ColumnSettings extends React.PureComponent {
    constructor(...args) {
        super(...args);

        const { originalColumns, handleColumnClose } = this.props;

        const tempData = []
        originalColumns.map(column => {
            const newColumn = {...column};
            tempData.push(newColumn)});
        const columnsToShow = 3;

        debugger;
        this.state = {
          
            tempData,
            forceRefresh: true,
            columnsToShow,
            maxPerColumn: Math.ceil(tempData.length / columnsToShow )


        };
    }

    componentDidMount = async () => {
       

    };

    componentDidUpdate = (prevProps, prevState) => {
   
    }

    handleChangeSwitch = (event, index) => {
        const { tempData } = this.state;
        debugger;
        tempData[index].show = event.target.checked;
        
            this.setState({ tempData, forceRefresh: !this.state.forceRefresh });
        
    }

    handleSetDefault = (event) => {
        const {tempData} = this.state;
        tempData.forEach(column => {
            column.show = column.default;
        })
        debugger;
       this.setState({tempData, forceRefresh: !this.state.forceRefresh} );
    };

    handleCancel = () => {
        this.props.cancel();
    }

    handleSave = () => {
        this.props.updateColumns(this.state.tempData);
    }

   
    render() {
        const { tempData, columnsToShow, maxPerColumn } = this.state;
        const { classes } = this.props;
        const eachColumn = new Array(columnsToShow).fill(1);
debugger;
        return (
            <div className={classes.root} >
                <div className={classes.content}>
                    <div className={classes.title}>COLUMN SETTINGS
                        <div style={{float: 'right'}}>
                            <Button
                                variant='contained'
                                size="small"
                                onClick={this.handleSetDefault}
                            >Default</Button>
                        </div>
                    </div>

                    {eachColumn.map((c, colIndex) => {
                        return (
                            <>
                                <div className={classes.column}>
                                    {this.state.tempData.map((column, index) => (
                                        <>
                                            {index >= (maxPerColumn * colIndex) && index < (maxPerColumn * (colIndex+1)) && (
                                                <div>
                                                    <div className={classes.item}>{column.label}</div>
                                                    {index >= 0 && (
                                                        <Switch
                                                            checked={column.show}
                                                            onChange={(e) => (this.handleChangeSwitch(e, index))}
                                                            color="primary"
                                                            name={`switch-${column.id}`}
                                                            disabled={index === 0}
                                                            inputProps={{ 'aria-label': 'checkbox' }}
                                                        />
                                                    )}
                                                </div>
                                            )}

                                        </>
                                    ))
                                    }
                                </div>
                                {colIndex !== columnsToShow - 1 && (
                                    <div className={classes.vertLine}> </div>
                                )}
                        </>
                    )
                })
                }

            </div>
            <div className={classes.buttonArea}>
                    <Button size="small" onClick={this.handleCancel} style={{marginRight: 18}}>cancel</Button>
                    <Button size="small" variant="contained" color="primary" onClick={this.handleSave}>Update</Button>
                </div>
      </div>
        )
    }
}

ColumnSettings.propTypes = {
    classes: PropTypes.object.isRequired,

};

export default withStyles(styles)(ColumnSettings);
